export interface ElementPosition {
  left: number;
  top: number;
}

export type ElementPositions = Map<HTMLElement, ElementPosition>;

export const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

export function prefersReducedMotion() {
  return typeof window !== "undefined" && window.matchMedia?.(REDUCED_MOTION_QUERY).matches === true;
}

export function captureElementPositions(elements: Iterable<HTMLElement>): ElementPositions {
  return new Map(
    Array.from(elements, (element) => {
      const rect = element.getBoundingClientRect();
      return [element, { left: rect.left, top: rect.top }] as const;
    }),
  );
}

export function animateElementPositions(
  before: ElementPositions,
  options: {
    duration: number;
    easing: string;
    shouldSkip?: (element: HTMLElement) => boolean;
  },
) {
  if (prefersReducedMotion() || typeof requestAnimationFrame === "undefined") return;

  requestAnimationFrame(() => {
    before.forEach((oldPosition, element) => {
      if (!element.isConnected || options.shouldSkip?.(element) || typeof element.animate !== "function") return;
      const rect = element.getBoundingClientRect();
      const x = oldPosition.left - rect.left;
      const y = oldPosition.top - rect.top;
      if (Math.abs(x) < 1 && Math.abs(y) < 1) return;

      element.animate([{ translate: `${x}px ${y}px` }, { translate: "0px 0px" }], {
        duration: options.duration,
        easing: options.easing,
      });
    });
  });
}
